
jQuery(function($){ // use jQuery code inside this to avoid "$ is not defined" error
	jQuery('#type-filter').on("change", function(e){
		
		//var url = replaceUrlParam(window.location.href, 'source', jQuery(this).val());
		var val = jQuery(this).val();
		var href = new URL(window.location.href);
		if(val) {
			href.searchParams.set('source', val);
		} else {
			href.searchParams.delete('source');
		}
		

		window.location.href = href.toString();
	
	});
	if(jQuery('.infinite-item').length > 9) {
		var infinite = new Waypoint.Infinite({
			element: jQuery(".infinite-container")[0],
			more: '.search-more-link',
			onAfterPageLoad: function() {
				infinite.destroy();
			}
		});
		infinite.destroy();
	} 
	
	// Listen for the click on the button, and then trigger the event
	$(document).on('click', '.search-more-link', function(e) {
		e.preventDefault();
		jQuery(this).text('Loading').addClass('disabled');
		infinite.waypoint.trigger();
	});
});
